<template>
  <div class="template-pie-wrapper">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs';

export default {
  extends: Doughnut,
  name: 'TemplateEventsStatusPieChart',
  props: {
    templateEvents: {
      type: Array,
      required: true,
    },
  },
  methods: {
    updateChart() {
      const statusOrder = ['queued', 'sent', 'delivered', 'failed'];

      const statusLabels = {
        queued: this.$t('TEMPLATE_EVENTS_REPORT.STATUS.QUEUED'),
        sent: this.$t('TEMPLATE_EVENTS_REPORT.STATUS.SENT'),
        delivered: this.$t('TEMPLATE_EVENTS_REPORT.STATUS.DELIVERED'),
        failed: this.$t('TEMPLATE_EVENTS_REPORT.STATUS.FAILED'),
      };

      const colorMap = {
        queued: '#616161',
        sent: '#4dd0e1',
        delivered: '#2e7d32',
        failed: '#e53935',
      };

      const grouped = {};
      statusOrder.forEach(status => {
        grouped[status] = 0;
      });

      this.templateEvents.forEach(msg => {
        const key = msg.status_code || 'queued';
        if (grouped[key] !== undefined) {
          grouped[key] += 1;
        }
      });

      let labels = statusOrder.map(s => statusLabels[s]);
      let data = statusOrder.map(s => grouped[s]);
      let colors = statusOrder.map(s => colorMap[s]);

      if (data.every(v => v === 0)) {
        labels = [this.$t('TEMPLATE_EVENTS_REPORT.CHART.NO_DATA')];
        data = [1];
        colors = ['#d3d3d3'];
      }

      this.renderChart(
        {
          labels,
          datasets: [
            {
              data,
              backgroundColor: colors,
            },
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          cutoutPercentage: 45,
          legend: { display: false },
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                const dataset = data.datasets[tooltipItem.datasetIndex];
                const label = data.labels[tooltipItem.index] || '';
                const value = dataset.data[tooltipItem.index] || 0;
                return `${label}: ${value}`;
              },
            },
          },
          animation: {
            animateRotate: true,
            animateScale: true,
            onComplete: function () {
              const chart = this.chart;
              const ctx = chart.ctx;
              ctx.font = '14px sans-serif';
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.fillStyle = '#000';

              const dataset = chart.config.data.datasets[0];
              const total = dataset.data.reduce((sum, val) => sum + val, 0);

              chart.getDatasetMeta(0).data.forEach((arc, i) => {
                const value = dataset.data[i];
                if (total === 0) return;

                const percent = (value / total) * 100;
                if (percent < 5) return;

                const centerX = arc.tooltipPosition().x;
                const centerY = arc.tooltipPosition().y;
                const text = `${percent.toFixed(1)}%`;

                ctx.fillText(text, centerX, centerY);
              });
            },
          },
        }
      );
    },
  },
  watch: {
    templateEvents: {
      handler() {
        this.updateChart();
      },
    },
  },
  mounted() {
    this.updateChart();
  },
};
</script>

<style scoped>
.template-pie-wrapper {
  width: 300px;
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.template-pie-wrapper canvas {
  max-height: 260px;
  max-width: 260px;
}

.template-pie-wrapper .chartjs-legend {
  max-height: 60px;
  overflow-y: auto;
}
</style>
